<template>
  <div class="app-container security-alert-page">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" label-width="90px" size="mini">
        <div class="formItemBox">
          <el-form-item label="仓库名称:">
            <span v-if="isAdminLogin!=1">{{  tenantName}}</span>
            <el-select v-model="searchFrom.tenantCode" size="mini" filterable placeholder="请选择仓库名称" v-else>
              <el-option v-for="(item, index) in keHuOptions" :key="index" :label="item.remark" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核实状态:">
            <el-select v-model="searchFrom.readFlag" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="未核实" value="1"></el-option>
              <el-option label="已核实" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核实结果:">
              <el-input placeholder="" v-model="searchFrom.checkResult" ></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--表格-->
    <div class="chuKuZuoyeWarp-body-table" :style="{ height: h }">
      <el-table :data="tableListData" ref="table" v-loading="loading" bordersize="mini"  class="table" height="100%" style="width: 100%" center border @row-mouse-enter="handleRowMouseEnter">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="heshiFn(scope.row)" v-if="scope.row.readFlag == 1">核实</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="核实状态" width="">
        <template slot-scope="scope">
          <!-- 核实状态 1 未核实，2 已核实 -->
          <div>
            <span :class="{ 'read-row': scope.row.readFlag === 2 }" v-if="scope.row.readFlag == 1" style="color: red;">未核实</span>
            <span :class="{ 'read-row': scope.row.readFlag === 2 }" v-if="scope.row.readFlag == 2">已核实</span>
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="tenantName" label="仓库">
          <template slot-scope="scope">
            <div @mouseenter="handleRowMouseEnter(scope.row)">
              <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ scope.row.tenantName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="alarmTime" label="告警时间">
          <template slot-scope="scope">
            <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ dateFormat(scope.row.alarmTime) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="deviceId" label="设备序列号">
          <template slot-scope="scope">
            <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ scope.row.deviceId }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="channelName" label="通道名称">
          <template slot-scope="scope">
            <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ scope.row.channelName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="描述">
          <template slot-scope="scope">
            <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="告警照片">
          <template slot-scope="scope">
            <div>
              <img @click="showLargeImage(scope.row.pictureUrl)"
              :class="{ 'read-image': scope.row.readFlag === 2 }"
              :src="scope.row.pictureUrl" style="height: 50px;width: 50px;"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="checkResult" label="核实结果">
          <template slot-scope="scope">
            <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ scope.row.checkResult }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="checkUserName" label="核实人名称">
          <template slot-scope="scope">
            <span :class="{ 'read-row': scope.row.readFlag === 2 }">{{ scope.row.checkUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="checkTime" label="核实时间">
          <template slot-scope="scope">
            <div>
              <span :class="{ 'read-row': scope.row.readFlag === 2 }" v-if="scope.row.checkTime">{{ scope.row.checkTime | dateFormat }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <div class="pags" style="text-align: left">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[25, 50, 100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 核实弹窗 -->
    <el-dialog :visible.sync="verifyDialogVisible" width="820px"
      :close-on-click-modal="false" @close="closeVerifyDialog">
      <span slot="title" class="verify-dialog-footer" style="color: #fff;">核实</span>
      <el-form label-width="90px" size="mini" class="verify-form">
        <el-form-item label="核实结果:">
          <el-radio-group v-model="verifyForm.checkResult" @change="handleCheckResultChange">
            <el-radio
              v-for="option in checkResultOptions"
              :key="option.value"
              :label="option.label">
              {{ option.label }}
            </el-radio>
          </el-radio-group>
          <el-input
            v-if="otherCheckResultVisible"
            v-model="verifyForm.checkResult"
            class="other-check-result"
            size="mini"
            placeholder="请输入核实结果">
          </el-input>
        </el-form-item>
        <el-form-item label="告警图片:">
          <img
            v-if="verifyForm.pictureUrl"
            class="verify-image"
            :src="verifyForm.pictureUrl"
            alt="告警图片">
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer verify-dialog-footer">
        <el-button size="mini" @click="verifyDialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" :loading="verifySubmitting" @click="submitVerify">确定</el-button>
      </span>
    </el-dialog>
    <!-- 图片放大弹窗 -->
    <el-dialog :visible.sync="imageDialogVisible" :title="'告警照片预览'" width="60%"
      center @close="closeImageDialog">
      <div class="image-preview-container">
        <img :src="currentImageUrl" alt="告警照片" style="max-width: 100%; max-height: 70vh; display: block; margin: 0 auto;"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { dateTimeFormat } from '@/utils/util'
import { findShWhList, videoAlertList, videoAlertUpdateRead } from '@/api/data-center-server'
export default {
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      btnFlg: [],
      btnIdArr: [],
      h: '500px',
      tableListData: [],
      keHuOptions: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      checkResultOptions: [
        { label: '现场作业人员或司机', value: '1' },
        { label: '现场作业车辆', value: '2' },
        { label: '管理人员巡查', value: '3' },
        { label: '外来人员参观', value: '4' },
        { label: '其他情况', value: '5' }
      ],
      total: 0,
      loading: false,
      isAdminLogin: localStorage.getItem('isAdmin'), // 0否1是
      tenantCode: localStorage.getItem('tenantCode'),
      tenantName: localStorage.getItem('tenantName'),
      // 新增数据属性
      imageDialogVisible: false, // 图片弹窗显示状态
      currentImageUrl: '', // 当前显示的图片URL
      hoveredRowId: null, // 当前悬浮的行ID
      verifyDialogVisible: false,
      verifySubmitting: false,
      otherCheckResultVisible: false,
      verifyForm: {
        id: null,
        checkResult: '',
        pictureUrl: ''
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  },
  created () {
    // this.btnFlg = getBtn(this.btnIdArr, '/wmsRukuStorage')
    if (this.isAdminLogin != 1) {
      this.$set(this.searchFrom, 'tenantCode', this.tenantCode)
    }
    this.getList()
    this.getTenantByWareCategoryS()
  },
  methods: {
    // 时间格式化
    dateFormat: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
    },
    // 字典-查询客户
    getTenantByWareCategoryS () {
      findShWhList()
        .then((res) => {
          this.keHuOptions = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 主数据
    getList () {
      this.loading = true
      videoAlertList(this.searchFrom)
        .then((res) => {
          this.loading = false
          this.total = res.total
          this.tableListData = res.list
        })
        .catch((err) => {
          this.loading = false
          DonMessage.error(err.message)
        })
    },
    // 查询
    chaxun () {
      if (this.isAdminLogin != 1) {
        this.$set(this.searchFrom, 'tenantCode', this.tenantCode)
      }
      this.getList(this.searchFrom)
    },
    // 重置
    chongZhi () {
      // this.searchFrom.tenantCode = null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      if (this.isAdminLogin != 1) {
        this.$set(this.searchFrom, 'tenantCode', this.tenantCode)
      }
      this.getList(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 显示大图
    showLargeImage (imageUrl) {
      this.currentImageUrl = imageUrl
      this.imageDialogVisible = true
    },
    // 关闭图片弹窗
    closeImageDialog () {
      this.imageDialogVisible = false
      this.currentImageUrl = ''
    },
    // 设置成已读
    videoAlertUpdateRead (row) {
      videoAlertUpdateRead({
        id: row.id
      })
        .then((res) => {
          // readFlag 1未读 2已读
          this.getList()
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 处理鼠标悬浮行事件
    handleRowMouseEnter (row, column, event) {
      // console.log('鼠标进入行', row, '事件对象:', event)
      // 确认行数据中是否有readFlag属性
      // console.log('当前行readFlag:', row.readFlag)
      if (row.readFlag === 1) {
        // console.log('准备标记为已读')
        // this.videoAlertUpdateRead(row)
      }
    },
    heshiFn (row) {
      const checkResult = row.checkResult === null || row.checkResult === undefined
        ? ''
        : String(row.checkResult)
      this.verifyForm = {
        id: row.id,
        checkResult: checkResult,
        pictureUrl: row.pictureUrl || ''
      }
      this.otherCheckResultVisible = checkResult === '其他情况' ||
        (checkResult !== '' && !this.checkResultOptions.some(option => option.label === checkResult))
      this.verifyDialogVisible = true
    },
    handleCheckResultChange (checkResult) {
      this.otherCheckResultVisible = checkResult === '其他情况'
    },
    // 提交核实结果
    submitVerify () {
      if (!this.verifyForm.checkResult) {
        DonMessage.error('请选择核实结果')
        return
      }
      this.verifySubmitting = true
      videoAlertUpdateRead({
        id: this.verifyForm.id,
        checkResult: this.verifyForm.checkResult
      })
        .then(() => {
          this.$message({
            message: '核实成功',
            type: 'success'
          })
          this.verifySubmitting = false
          this.verifyDialogVisible = false
          this.getList()
        })
        .catch((err) => {
          this.verifySubmitting = false
          DonMessage.error(err.message)
        })
    },
    closeVerifyDialog () {
      this.verifyForm = {
        id: null,
        checkResult: '',
        pictureUrl: ''
      }
      this.otherCheckResultVisible = false
    }
  }

}
</script>

<style lang="less" scoped>
.security-alert-page {
  .demo-form-inline {
    // display: flex;
    // align-items: flex-start;
    width: 100%;
  }

  .formItemBox {
    flex: 1 1 auto;
    min-width: 0;
    flex-wrap: nowrap;

    /deep/ .el-form-item {
      width: auto;
      flex: 0 1 auto;
      margin-right: 20px;
    }

    /deep/ .el-form-item__content {
      min-width: 180px;
    }
  }

  .searchBtnBox {
    flex-shrink: 0;
  }
}

.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    text-align: center;
  }
  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      width: 100%;
      display: flex;
      font-size: 14px;
      ul {
        padding-left: 10px;
        margin: 0;
        flex: 1;
        flex-direction: column;
        // display: flex;
        li {
          float: left;
          margin-top: 5px;
          margin-left: 10px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
}
.image-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
.verify-form /deep/ .el-form-item__content {
  line-height: 28px;
}
.verify-form /deep/ .el-radio {
  margin-right: 18px;
  margin-bottom: 8px;
}
.other-check-result {
  display: block;
  width: 100%;
  margin-top: 4px;
}
.verify-image {
  display: block;
  width: 100%;
  max-width: 680px;
  max-height: 500px;
  object-fit: contain;
}
.verify-dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.verify-dialog-title {
  display: block;
  text-align: center;
}
// 已读行样式
.read-row {
  color: #909399 !important; /* 灰色字体 */
}

// 已读图片样式
.read-image {
  opacity: 0.6; /* 降低图片透明度 */
  filter: grayscale(50%); /* 添加灰度效果 */
}
</style>
